import {BUSINESS_ANALYSE} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/businessAnalyse/index.vue'),
    name: BUSINESS_ANALYSE,
    path: 'business/analyse',
    meta: {
        name: BUSINESS_ANALYSE,
        title: '风险报告'
    }
};